import React, { Component } from 'react';

import style from './PlaylistButton.module.scss';

const PlaylistButton = ({
  handleMouseDown,
  handleMouseUp,
  registerProgressBar,
  index,
  allowScroll,
  disallowScroll,
}) => (
  <div className={`scaleDown playlist-button ${style.viewButtonWrapper}`}>
    <div
      className={`view-button ${style.viewButton}`}
      onMouseDown={handleMouseDown}
      onTouchStart={e => {
        if (disallowScroll) {
          disallowScroll();
        }
        handleMouseDown(e);
      }}
      onMouseUp={handleMouseUp}
      onTouchEnd={e => {
        if (allowScroll) {
          allowScroll();
        }
        handleMouseUp(e);
      }}
    >
      <div className={style.pulse}>
        <div className={style.pulseInner} />
        <div className={style.pulseInner2} />
      </div>

      <span>HOLD</span>
    </div>

    <svg xmlns="http://www.w3.org/2000/svg" className={style.progressWrapper}>
      <circle className={`${style.progressBar}`} cx="50%" cy="50%" r="48%" />
      <circle
        className={`${style.progress} view-button-progress progressBar${index}`}
        ref={el => registerProgressBar(el, index)}
        cx="50%"
        cy="50%"
        r="48%"
      />
    </svg>
  </div>
);

export default PlaylistButton;



// WEBPACK FOOTER //
// ./src/components/global/playlist/PlaylistButton.js